import { filter, reduce } from 'fp-ts/lib/Array';
import { pipe } from 'fp-ts/lib/function';
import { toEntries } from 'fp-ts/lib/Record';

export const pick =
  <T extends Record<string, unknown>>() =>
  <K extends keyof T, R extends Pick<T, K>>(...props: K[]) =>
  (data: T): R =>
    pipe(
      data,
      toEntries,
      filter(([k]) => props.includes(k as K)),
      reduce({} as R, (res, [k, v]) => ({ ...res, [k]: v }))
    );
